import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-2" }
const _hoisted_5 = { class: "col-6 col-md-2" }
const _hoisted_6 = { class: "col-6 col-md-2" }
const _hoisted_7 = { class: "col-6 col-md-2" }
const _hoisted_8 = { class: "col-6 col-md-2" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-md-12 table-responsive" }
const _hoisted_11 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_12 = { class: "nowrap-celular" }
const _hoisted_13 = { class: "nowrap-celular" }
const _hoisted_14 = { class: "nowrap-celular" }
const _hoisted_15 = { class: "text-center text-nowrap" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "row mb-2" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "row mb-2" }
const _hoisted_25 = { class: "col-md-9" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-12 text-center" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "text-danger fw-bold" }

import { defineComponent, onMounted, reactive } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";

//servicos
import * as service from "@/services/clientesContratosService";
import { fdata, fdataUS } from "@/utils/funcoes";

//componentes
import Paginador from "@/components/Paginador/Index.vue";
import ImgUsuario from "@/components/Imagens/ImgUsuario.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

var controle = reactive({
  filtros: {
    statusId: null,
    tipoId: null,
    paginaAtual: 1,
    tamanhoPagina: 10
  } as unknown as service.Filtros,
  itens: [] as service.Contrato[],
  totalRegistros: 0,

  listaStatus: [
    { valor: null, descricao: "- Todos -" },
    { valor: true, descricao: "Ativos" },
    { valor: false, descricao: "Inativos" },
  ],
  itemExcluir: null as service.Contrato | null,
  janExcluir: false,
  status: "",
  erro: "",

  itemExtender: null as service.Contrato | null,
  janExtender: false,
  formExtender: {
    dataInicial: null as string | null,
    mesesExtender: 12,
  },
  statusExtender: "",
  erroExtender: "",

  ordenacao: {
    coluna: '',
    asc: true
  },
})

onMounted(async () => {
  pesquisar();
})

async function pesquisar() {

  service.obter(controle.filtros)
    .then(r => {
      controle.itens = r;
      controle.totalRegistros = 1000;
    })
    .catch(erro => {
      controle.erro = erro;
    })
}

function ordenarPor(coluna: string) {
  if (controle.ordenacao.coluna === coluna) {
    controle.ordenacao.asc = !controle.ordenacao.asc;
  } else {
    controle.ordenacao.coluna = coluna;
    controle.ordenacao.asc = true;
  }
  controle.itens.sort((a, b) => {
    let valA = (a as Record<string, any>)[coluna];
    let valB = (b as Record<string, any>)[coluna];
    if (typeof valA === 'string') valA = valA.toLowerCase();
    if (typeof valB === 'string') valB = valB.toLowerCase();
    if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
    if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
    return 0;
  });
}

function pergExcluir(item: service.Contrato) {
  controle.janExcluir = true;
  controle.itemExcluir = item;
}

function excluir() {
  if (controle.itemExcluir) {
    service.excluir(controle.itemExcluir.contratoId!)
      .then(() => {
        controle.janExcluir = false;
        pesquisar();
      })
      .catch(erro => {
        controle.erro = erro;
        controle.janExcluir = false;
      });
  }
}

function abrirExtender(item: service.Contrato) {
  controle.itemExtender = item;
  controle.formExtender = {
    dataInicial: fdataUS(item.dataFim) ?? fdataUS(new Date().toISOString()),
    mesesExtender: 12,
  };
  controle.erroExtender = "";
  controle.janExtender = true;
}

function confirmarExtender() {
  if (!controle.itemExtender) return;

  controle.statusExtender = "Extendendo contrato...";
  controle.erroExtender = "";

  service.extenderContrato({
    contratoId: controle.itemExtender.contratoId!,
    dataInicial: controle.formExtender.dataInicial,
    mesesExtender: controle.formExtender.mesesExtender,
  })
    .then(() => {
      controle.statusExtender = "";
      controle.janExtender = false;
      pesquisar();
    })
    .catch((erro) => {
      controle.erroExtender = `Erro ao extender contrato: ${erro.message || erro}`;
      controle.statusExtender = "";
    });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Contratos" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[20] || (_cache[20] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Nome",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
              onInput: pesquisar
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.nome]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "Contrato", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Nro Contrato.",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.contratoId) = $event)),
              onInput: pesquisar
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.contratoId]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "Vendedor", -1)),
            _createVNode(DropdownVendedores, {
              modelValue: _unref(controle).filtros.vendedorId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.vendedorId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "Plano", -1)),
            _createVNode(DropdownPlanos, {
              modelValue: _unref(controle).filtros.planoId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.planoId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[25] || (_cache[25] = _createElementVNode("label", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).filtros.statusId) = $event)),
              onChange: pesquisar
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("option", { value: null }, "- Todos -", -1),
              _createElementVNode("option", { value: 1 }, "Aguard. Assinatura", -1),
              _createElementVNode("option", { value: 2 }, "Ativo", -1)
            ]))], 544), [
              [_vModelSelect, _unref(controle).filtros.statusId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('contratoId'))),
                    class: "th-sortable"
                  }, "Id"),
                  _createElementVNode("th", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('nomeCompleto'))),
                    class: "th-sortable"
                  }, "Cliente / Empresa"),
                  _createElementVNode("th", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('planoId'))),
                    class: "th-sortable"
                  }, "Plano"),
                  _createElementVNode("th", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenarPor('vendedorId'))),
                    class: "th-sortable"
                  }, "Vendedor"),
                  _createElementVNode("th", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (ordenarPor('dataInicio'))),
                    class: "th-sortable"
                  }, "Inicio"),
                  _createElementVNode("th", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (ordenarPor('dataFim'))),
                    class: "th-sortable"
                  }, "Fim"),
                  _createElementVNode("th", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (ordenarPor('dataAssinatura'))),
                    class: "th-sortable"
                  }, "Assinatura"),
                  _createElementVNode("th", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (ordenarPor('statusId'))),
                    class: "th-sortable"
                  }, "Status"),
                  _cache[26] || (_cache[26] = _createElementVNode("th", null, "Opções", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.contratoId), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.cliente != null ? item.cliente.nome :
                    item.empresa != null ? item.empresa.nome : ''), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.plano.nome), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.vendedor?.nomeCompleto), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataInicio)), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataFim)), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataAssinatura)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", item.statusId === 2 ? 'badge-soft-success' : 'badge-soft-warning'])
                      }, _toDisplayString(item.status.descricao), 3)
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_RouterLink, {
                          to: '/contratos/cadastro/' + item.contratoId
                        }, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          title: "Extender Contrato",
                          onClick: ($event: any) => (abrirExtender(item))
                        }, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "flaticon-refresh fs-5 text-primary" }, null, -1)
                        ]))], 8, _hoisted_16),
                        _createElementVNode("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (pergExcluir(item))
                        }, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("i", { class: "flaticon-delete fs-5 text-danger" }, null, -1)
                        ]))], 8, _hoisted_17)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(controle).itens.length) + " Registros ", 1),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: _unref(controle).filtros.paginaAtual ?? 1,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina ?? undefined,
              "total-registros": _unref(controle).totalRegistros,
              onOnChange: _cache[13] || (_cache[13] = (el) => {
              _unref(controle).filtros.paginaAtual = el.paginaAtual;
              _unref(controle).filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar()
            })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "total-registros"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: '/'
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: 'janExcluir',
      titulo: 'Atenção',
      exibir: _unref(controle).janExcluir,
      onOnFechou: _cache[14] || (_cache[14] = ($event: any) => (_unref(controle).janExcluir = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[15] || (_cache[15] = ($event: any) => (excluir()))
    }, {
      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-12 fw-bold fs-6" }, " Deseja excluir este registro? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"]),
    _createVNode(MsgBox, {
      id: 'janExtender',
      titulo: 'Extender Contrato ' + (_unref(controle).itemExtender?.contratoId ?? ''),
      exibir: _unref(controle).janExtender,
      onOnFechou: _cache[18] || (_cache[18] = ($event: any) => (_unref(controle).janExtender = false)),
      "botao-gravar": true,
      "botao-fechar": true,
      onOnGravar: _cache[19] || (_cache[19] = ($event: any) => (confirmarExtender()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-3" }, " Data Inicial ", -1)),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(controle).formExtender.dataInicial) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formExtender.dataInicial]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-md-3" }, " Meses a Extender ", -1)),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "1",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(controle).formExtender.mesesExtender) = $event))
            }, null, 512), [
              [
                _vModelText,
                _unref(controle).formExtender.mesesExtender,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(controle).statusExtender), 1),
            _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(controle).erroExtender), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["titulo", "exibir"])
  ], 64))
}
}

})